import React from 'react';
import css from './LeadFlowPage.module.css';
import { LayoutSingleColumn, Page } from '../../components';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { logout } from '../../ducks/auth.duck';
import FooterContainer from '../FooterContainer/FooterContainer';
import LeadFlowNavbar from './components/LeadFlowNavbar/LeadFlowNavbar';
import HeroSection from './components/HeroSection/HeroSection';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import BenefitsSection from './components/BenefitsSection/BenefitsSection';
import CtaBannerSection from './components/CtaBannerSection/CtaBannerSection';
import QuestionSection from '../CustomLandingPage/components/QuestionSection/QuestionSection';

const LeadFlowPageComponent = props => {
  const { currentUser, isAuthenticated, onLogout } = props;

  return (
    <Page
      title="LeadFlow — See Live Planning Projects Before Your Competitors"
      description="Access early-stage construction opportunities up to 8 weeks before they hit the market."
      scrollingDisabled={false}
    >
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        isLandingPage={true}
        topbar={
          <LeadFlowNavbar
            currentUser={currentUser}
            isAuthenticated={isAuthenticated}
            onLogout={onLogout}
          />
        }
        footer={<FooterContainer isLandingPage={true} />}
      >
        <HeroSection currentUser={currentUser} />
        <FeaturesSection />
        <BenefitsSection />
        <CtaBannerSection currentUser={currentUser} />
        <QuestionSection />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { isAuthenticated } = state.auth;
  return { currentUser, isAuthenticated };
};

const mapDispatchToProps = dispatch => ({
  onLogout: historyPush => dispatch(logout(historyPush)),
});

const LeadFlowPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(LeadFlowPageComponent);

export default LeadFlowPage;
